import type {
  LedgerAccountsListResponse,
  LedgerAccountsQueryParams,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodLedgerAccountsQueryParamsSchema,
  zodLedgerAccountsResponseSchema,
} from './validations';

/**
 * Fetches ledger accounts (Kontenplan) from the API with the given query parameters.
 *
 * @param queryParams - The query parameters for fetching ledger accounts.
 * @param options - Additional request options.
 * @returns The paginated ledger account data.
 * @throws VestigasHTTPError if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Ledger-Accounts/operation/list_ledger_accounts_ledger_accounts_get
 */
export const fetchLedgerAccounts = async (
  queryParams: Partial<LedgerAccountsQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.LEDGER_ACCOUNT.GET_ALL(), {
      searchParams: withoutObjectKeysWhereValueIs(queryParams, [
        undefined,
        '',
      ]) as Record<string, boolean | number | string | undefined>,
      ...options,
      validate: {
        ...options?.validate,
        response: zodLedgerAccountsResponseSchema,
        searchParams: zodLedgerAccountsQueryParamsSchema,
      },
    })
    .json<LedgerAccountsListResponse>();
